import consumer from "./consumer";

let subscription = null;

export function subscribeToNotifications(Alpine) {
  if (subscription) return;

  subscription = consumer.subscriptions.create("NotificationChannel", {
    received(data) {
      if (data.type === "unread_count") {
        Alpine.store("notifications").unreadCount = data.count;
      }
    }
  });
}

export function unsubscribeFromNotifications() {
  if (subscription) {
    subscription.unsubscribe();
    subscription = null;
  }
}
